module.exports = __webpack_public_path__ + "components/gallery-upload-button/static/icon-sort-by-3d1be0cc544da98fae42121a50085cd2.svg";